export default __webpack_public_path__ + "static/media/zenith-logo.c2414ade.svg";